import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Redirect, useHistory, useLocation } from 'react-router-dom';
import conf from '../../conf';

import { getEconomicThresholdStates } from '../../lib/side-effects/economic-nexus';
import { getSystemErrorMessaging } from '../../lib/side-effects/error';
import { startQuestionnaireCamundaProcess } from '../../lib/side-effects/prequal-questionnaire';
import { selectState } from '../../selectors';
import { removeQuestion } from '../../store/prequal-questionnaire';
import { getCtaUrlWithCampaignId } from '../helpers/prequal-questionnaire';

const PrequalLandingPage = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { questionnaire, economicNexus } = useSelector(selectState);
  const [redirectRegistrations, setRedirectRegistrations] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    if (!questionnaire.config?.questions.length) {
      dispatch(getSystemErrorMessaging({ errorCode: 'prequalQuestionnaireError' }));
    }
    if (questionnaire.config?.name === 'registrations' && !economicNexus.fetchedThresholds) {
      dispatch(getEconomicThresholdStates());
    }
    dispatch(startQuestionnaireCamundaProcess());
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: leaving as is
  useEffect(() => {
    if (questionnaire.config?.name === 'registrations' && economicNexus.fetchedThresholds) {
      if (!economicNexus.exceedingThreshold.length && !economicNexus.approachingThreshold.length) {
        setRedirectRegistrations(true);
      }
      if (!economicNexus.exceedingThreshold.length) {
        dispatch(removeQuestion('exceedingNexusThresholds'));
      }
      if (!economicNexus.approachingThreshold.length) {
        dispatch(removeQuestion('approachingNexusThresholds'));
      }
    }
  }, [economicNexus]);

  const startPageData = questionnaire?.config?.startPage.content;
  if (!startPageData) {
    return (
      <Redirect
        to={{
          pathname: '/question/0',
          search: window.location.search,
        }}
      />
    );
  }

  if (redirectRegistrations) {
    return (
      <Redirect
        to={{
          pathname: '/avalara-licensing',
          search: window.location.search,
        }}
      />
    );
  }

  const campaignId = questionnaire.config?.campaignId || '';
  // The actionLink1Url is only used for registrations which goes to home screen with query param.
  // In the future, may need to refactor how urls that use configs are handled by template and maybe adding query params
  const ctaLink1Url = startPageData.actionLink1Url
    ? `${getCtaUrlWithCampaignId(campaignId, conf.HOME_URL)}&openNexusMap=true`
    : undefined;

  return (
    <>
      <SRow className='margin-left-sm margin-right-sm' data-ref='buy.prequal.container'>
        <SCol span='8' className='text-left pad-bottom-none pad-left-none'>
          <h1 data-ref='buy.prequal.startPage.header'>{startPageData.heading}</h1>
          <p className='margin-top-md margin-bottom-xl'>{startPageData.body}</p>
          {startPageData.subText && (
            <p data-ref='buy.prequal.startPage.subText' className='text-md margin-top-xl'>
              {startPageData.subText}
            </p>
          )}
          <SRow className='margin-top-xl pad-top-lg'>
            <button
              type='button'
              data-ref='buy.prequal.startPage.back-button'
              className='button secondary large active'
              onClick={() => history.goBack()}
            >
              {t('client.buttons.back')}
            </button>
            <Link
              data-ref='buy.prequal.startPage.next-button'
              to={`/question/0${location.search}`}
              className='button primary large'
            >
              {startPageData.actionButtonText}
            </Link>

            {startPageData.actionLink1Text && (
              <>
                <p className='margin-left-xs margin-top-sm'>{' or '} </p>
                <a
                  className='text-underline pad-left-xs justify-bottom margin-top-sm'
                  href={ctaLink1Url}
                  target='_blank'
                  rel='noreferrer'
                >
                  {startPageData.actionLink1Text}
                </a>
              </>
            )}
          </SRow>
        </SCol>
        <SCol span='4' className='pad-bottom-none'>
          <img
            data-ref='buy.prequal.startPage.image'
            className='pad-top-md'
            src={`${conf.ASSET_PATH}/assets/images/prequal/${startPageData.imageFile}`}
            alt=''
            style={{ maxWidth: '400px' }}
          />
        </SCol>
      </SRow>
    </>
  );
};

export default PrequalLandingPage;
